// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import {
  WizardForm,
  FormTitleH5
} from '../../../../../components/WizardFormStyles';
import { DefaultIcon } from '../../../../../components/Icon';
import Input from '../../../../../components/Input';
import DropdownInput from '../../../../../components/DropdownInput';
import SubmitButton from '../../../../../components/SubmitButton';
import { handleNext } from '../handleSubmit';
import RadioInput from '../../../../../components/RadioInput';
import {
  requiredBooleanField,
  requiredField
} from '../../../../../utilities/validations';
import { countryOptions } from '../../../../../utilities/countries';
type Props = {
  error?: string,
  handleSubmit: Function,
  submitting: boolean,
  diff_mailing_address: boolean
};

class MailingAddress extends Component<Props> {
  // handleRadioChange = (event, value: string) => {
  //   localStorage.setItem('diff_mailing_address_changed', value);
  // };

  render() {
    return (
      <WizardForm onSubmit={this.props.handleSubmit}>
        <FormTitleH5 hideOnMobile>
          <DefaultIcon name="envelopeOpen" />
          <span>Mailing Address</span>
        </FormTitleH5>

        <Field
          name="diff_mailing_address"
          label="Do you have a different mailing address?"
          component={RadioInput}
          options={[
            { text: 'Yes', value: 'yes' },
            { text: 'No', value: 'no' }
          ]}
          validate={requiredBooleanField}
          // onChange={this.handleRadioChange}
        />
        {this.props.diff_mailing_address === 'yes' && (
          <>
            <Field
              name="mailing_address_attributes.address_attributes.address"
              label="Street address"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="mailing_address_attributes.address_attributes.city"
              label="City/Town"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="mailing_address_attributes.address_attributes.state"
              label="State"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="mailing_address_attributes.address_attributes.zip"
              label="Zip/Postal code"
              component={Input}
              validate={requiredField}
            />
            <Field
              name="mailing_address_attributes.address_attributes.country_code"
              label="Country"
              typeable
              component={DropdownInput}
              options={countryOptions}
              validate={requiredField}
            />
          </>
        )}
        <SubmitButton
          error={this.props.error}
          value="Next"
          disabled={this.props.submitting}
        />
      </WizardForm>
    );
  }
}

const selector = formValueSelector('verification');

const mapStateToProps = state => ({
  diff_mailing_address: selector(state, 'diff_mailing_address')
});

// export default reduxForm({
//   form: 'verification',
//   forceUnregisterOnUnmount: true,
//   destroyOnUnmount: false,
//   onSubmit: handleNext
//   // onSubmitSuccess: handleSubmitSuccess
//   // $FlowFixMe
// })(MailingAddress);

export default connect(
  mapStateToProps,
  null
)(
  reduxForm({
    form: 'verification',
    forceUnregisterOnUnmount: true,
    destroyOnUnmount: false,
    onSubmit: handleNext
    // onSubmitSuccess: handleSubmitSuccess
    // $FlowFixMe
  })(MailingAddress)
);
